import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import axios from "axios";
import { toast } from "react-toastify";
import Constant from "../Utils/Constant";

const EditUserForm = ({ editPopup, setEditPopup }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [newPassword, setPassword] = useState("");
  const [device, setDevice] = useState("");
  const [subscription, setSubscription] = useState("");
  const [address, setAddress] = useState("");
  const [proffesion, setProffesion] = useState("");
  const [gst, setGst] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [usertype, setUsertype] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isGstValid, setIsGstValid] = useState(true);
  const [date, setDate] = useState("");
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // <-- HIGHLIGHTED CHANGE: New state to track if a new plan is chosen
  const [newlySelectedPlan, setNewlySelectedPlan] = useState(null);

  useEffect(() => {
    const fetchSubscriptionPlans = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${Constant.BASE_URL}/subscription/admin-plans`
        );
        setSubscriptionPlans(response.data.subscription || []);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch subscription plans:", err);
        setError("Could not load subscription plans.");
        toast.error("Could not load subscription plans.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubscriptionPlans();
  }, []);

  const formatDate = (inputDate) => {
    if (!inputDate) return "";
    const dateObj = new Date(inputDate);
    const year = dateObj.getFullYear();
    const month = `${dateObj.getMonth() + 1}`.padStart(2, "0");
    const day = `${dateObj.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleClose = () => {
    setEditPopup(false);
  };

  useEffect(() => {
    if (editPopup) {
      setName(editPopup.name || "");
      setEmail(editPopup.email || "");
      setPhone(editPopup.phone || "");
      setAddress(editPopup.address || "");
      setDevice(editPopup.device || "");
      setCompanyname(editPopup.companyname || "");
      setPassword("");
      setGst(editPopup.gst || "");
      setProffesion(editPopup.proffesion || "");
      setDate(formatDate(editPopup.date));
      setUsertype(editPopup.usertype || "");
      setCreatedby(editPopup.createdby || "");
      setSubscription(editPopup.subscription || "");
      // <-- HIGHLIGHTED CHANGE: Reset the selected plan tracker when form opens
      setNewlySelectedPlan(null);
    }
  }, [editPopup]);

  const validatePhone = (phone) => /^\d{10}$/.test(phone);
  const validateGst = (gst) => true;

  const handleUpdate = async (e) => {
    e.preventDefault();
    const isPhoneValid = validatePhone(phone);
    const isGstValid = gst.trim() === "" ? true : validateGst(gst);
    setIsPhoneValid(isPhoneValid);
    setIsGstValid(isGstValid);

    if (isPhoneValid && isGstValid) {
      try {
        const userData = {
          email,
          name,
          phone,
          newPassword: newPassword || undefined,
          device,
          date: date ? formatDate(date) : undefined,
          address: address.trim() || undefined,
          proffesion,
          gst: gst.trim() || undefined,
          companyname: companyname.trim() || undefined,
          usertype,
        };

        // <-- HIGHLIGHTED CHANGE: Conditionally add the new plan to the request
        if (newlySelectedPlan) {
            userData.newSubscriptionPlan = newlySelectedPlan;
        }

        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          userData
        );
        if (response.status === 200) {
          toast.success("User Updated Successfully");
          setTimeout(() => handleClose(), 1500);
        }
      } catch (error) {
        console.error(error);
        const errorMessage = error.response?.data?.message || "Update failed";
        toast.error(errorMessage);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = () => setIsSubscriptionOpen(false);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Helper to find and display the current plan name
  const getSubscriptionPlanName = () => {
    if (isLoading) return "Loading...";
    if (error) return "Error";
    const currentPlan = subscriptionPlans.find(
        (p) => p.planevalidity === subscription
    );
    if (currentPlan) {
        return `Plan: ${currentPlan.planname} (${subscription})`;
    }
    // If the subscription is an ISO date, it won't match. Show a generic message.
    if (subscription && subscription.includes('T')) {
        return `Active Plan (Expires ${formatDate(subscription)})`;
    }
    return subscription || "Select";
  }


  return (
    <div className="popup-form">
      <div className="w-full flex items-center justify-center">
        <div className="bg-white p-4 rounded-md shadow-md py-3 px-1 w-fit">
          <div className="lg:w-[600px] xl:w-[630px] 2xl:w-[1350px] items-center justify-center">
            <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl 2xl:py-3">
              Edit User
            </div>
            <hr className="mt-1" />
            <form onSubmit={handleUpdate}>
              <div className="flex items-center justify-center lg:py- xl:py-5 2xl:py-14 lg:text-[10px] xl:text-[13px] 2xl:text-[30px]">
                <div className="pr-3 border-r">
                  <div className="flex justify-end py-3 mt-4">
                    <label htmlFor="name" className="flex items-center px-3">
                      Name :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="border-b border-gray-500 outline-none createuserline"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="usertype"
                      className="flex items-center px-3 mb-1"
                    >
                      UserType :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative borderuser">
                      <select
                        id="usertype"
                        className={`bg-white border-b border-gray-500 outline-none appearance-none createuserline ${
                          usertype ? "text-black" : "text-slate-500"
                        }`}
                        required
                        value={usertype}
                        onChange={(e) => setUsertype(e.target.value)}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Demo">Demo</option>
                        <option value="Sales">Sales</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <MdArrowDropDown className="text-1xl" />
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="phone"
                      className="flex items-center px-3 mb-1"
                    >
                      Phone :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="text"
                        id="phone"
                        className="border-b border-gray-500 outline-none createuserline"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Phone"
                        required
                      />
                      {!isPhoneValid && (
                        <p className="text-red-500">
                          Invalid phone format (10 digits)
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="email"
                      className="flex items-center px-3 mb-1"
                    >
                      Email :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="email"
                        id="email"
                        className="border-b border-gray-500 outline-none createuserline bg-gray-100"
                        placeholder="Email"
                        value={email}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="flex justify-end py-3 relative">
                    <label
                      htmlFor="password"
                      className="flex items-center px-3 mb-1"
                    >
                      New Password :
                    </label>
                    <input
                      type={togglePassword ? "text" : "password"}
                      id="password"
                      className="relative border-b border-gray-500 outline-none createuserline"
                      placeholder="Enter new password to update"
                      value={newPassword}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      onClick={() => setTogglePassword(!togglePassword)}
                      className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer"
                    >
                      {togglePassword ? <IoEye /> : <RiEyeCloseLine />}
                    </span>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="device"
                      className="flex items-center px-3 mb-1"
                    >
                      Device :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative borderuser">
                      <select
                        id="device"
                        className={`bg-white border-b border-gray-500 outline-none appearance-none createuserline ${
                          device ? "text-black" : "text-slate-500"
                        }`}
                        required
                        value={device}
                        onChange={(e) => setDevice(e.target.value)}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Android">Android</option>
                        <option value="IOS">IOS</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <MdArrowDropDown className="text-1xl" />
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="subscription"
                      className="flex items-center px-3 mb-1"
                    >
                      Subscription:<span className="text-red-500 ml-1">*</span>
                    </label>
                    <div className="relative createuserline">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsSubscriptionOpen(!isSubscriptionOpen);
                        }}
                        className={`w-full border-b border-gray-500 text-left bg-white flex justify-between items-center ${
                          subscription ? "text-black" : "text-slate-500"
                        }`}
                        disabled={isLoading}
                      >
                        <span className="truncate">
                          {getSubscriptionPlanName()}
                        </span>
                        <MdArrowDropDown
                          className={`transition-transform ${
                            isSubscriptionOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                      {isSubscriptionOpen && (
                        <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-md shadow-lg z-50 max-h-48 overflow-y-auto">
                          {subscriptionPlans
                            ?.filter((plan) =>
                              plan.planevisibility?.includes("Admin")
                            )
                            .map((plan, index) => (
                              <div
                                key={index}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // <-- HIGHLIGHTED CHANGE: Update both states
                                  setSubscription(plan.planevalidity);
                                  setNewlySelectedPlan(plan.planevalidity);
                                  setIsSubscriptionOpen(false);
                                }}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-slate-500"
                              >
                                {`Plan: ${plan.planname} (Validity: ${plan.planevalidity})`}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="w-fit pb-4 pl-1 pr-2 flex-col">
                  <div className="flex pb-3 relative justify-end">
                    <label
                      htmlFor="date"
                      className="flex items-center px-3 mb-1"
                    >
                      Date Of Birth :
                    </label>
                    <input
                      type="date"
                      id="date"
                      className="border-b border-gray-500 outline-none createuserline"
                      value={date}
                      max={formatDate(new Date())}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="address"
                      className="mb-1 flex items-center px-3"
                    >
                      Address :
                    </label>
                    <input
                      type="text"
                      id="address"
                      className="border-b border-gray-500 outline-none createuserline"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="address"
                    />
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="proffesion"
                      className="mb-1 flex items-center px-3"
                    >
                      Profession :<span className="text-red-500 ml-1">*</span>
                    </label>
                    <div className="text-center relative">
                      <select
                        id="proffesion"
                        className={`border-b border-gray-500 text-slate-500 appearance-none outline-none createuserline ${
                          proffesion ? "text-black" : "text-slate-500"
                        }`}
                        value={proffesion}
                        onChange={(e) => setProffesion(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Fabric Manufacturer">
                          Fabric Manufacturer
                        </option>
                        <option value="Garment Manufacturer">
                          Garment Manufacturer
                        </option>
                        <option value="Yarn Manufacturer">
                          Yarn Manufacturer
                        </option>
                        <option value="Trader & Broker">Trader & Broker</option>
                        <option value="Buyer">Buyer</option>
                        <option value="Designer">Designer</option>
                        <option value="Finisher">Finisher</option>
                        <option value="Other">Other</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                        <MdArrowDropDown className="text-1xl" />
                      </span>
                    </div>
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="gst"
                      className="mb-1 flex items-center px-3"
                    >
                      GST Number :
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="text"
                        id="gst"
                        className="text-[#BBB] border-b border-gray-500 outline-none createuserline"
                        value={gst}
                        onChange={(e) => setGst(e.target.value)}
                        placeholder="gstnumber"
                      />
                    </div>
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="companyname"
                      className="mb-1 flex items-center px-3"
                    >
                      Company Name:
                    </label>
                    <input
                      type="text"
                      id="companyname"
                      className="text-[#BBB] border-b border-gray-500 outline-none createuserline"
                      value={companyname}
                      onChange={(e) => setCompanyname(e.target.value)}
                      placeholder="Text"
                    />
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="createdby"
                      className="mb-1 flex items-center px-3"
                    >
                      Created By :
                    </label>
                    <input
                      type="text"
                      id="createdby"
                      className="text-[#BBB] border-b border-gray-500 outline-none createuserline bg-gray-100"
                      value={createdby}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 lg:pt-10 xl:pt-10 2xl:pt-10 lg:text-[10px] xl:text-[13px] 2xl:text-[30px]">
                <button
                  type="button"
                  onClick={handleClose}
                  className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                  style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-shrink-0 px-3 py-1 rounded-sm"
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserForm;